import { getUnityOrigin } from '@/lib/productHosts';

/**
 * Returns the set of trusted origins for postMessage validation.
 * Messages from any other origin should be ignored.
 */
export function getAllowedOrigins(): Set<string> {
  const origins = new Set<string>();

  // Same-origin (always trusted)
  origins.add(window.location.origin);

  // The 3D view iframe's origin, Unity or three.js, as getUnityBaseUrl chooses it
  const unityOrigin = getUnityOrigin();
  if (unityOrigin) origins.add(unityOrigin);

  return origins;
}

/**
 * Checks if a MessageEvent comes from a trusted origin.
 */
export function isAllowedOrigin(event: MessageEvent): boolean {
  // Same-origin messages (e.g. local iframe) have empty or matching origin
  if (!event.origin || event.origin === window.location.origin) return true;
  return getAllowedOrigins().has(event.origin);
}

/**
 * Returns the target origin for postMessage to the Unity iframe.
 * Uses the resolved Unity origin instead of '*'.
 */
export function getUnityTargetOrigin(): string {
  return getUnityOrigin() ?? window.location.origin;
}
